import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { AppComponent } from '../../app.component';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from '../../services/authservice/auth.service';
import { AppMapComponent } from "../../app-map.component";
import { UserService } from '../../services/user.service';
import { CaseDocumentService } from '../../services/documents.service';
import { GlobalService } from '../../services/global.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/components/shared/confirmation-dialog/confirmation-dialog.component';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Settings } from '../../services/settings';
import { Router } from "@angular/router";
import { AgenciesService } from 'src/app/services/agencies.service';
import { InactivityService } from 'src/app/services/inactivity.service';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { forkJoin, pipe } from 'rxjs';
import { ServiceDefService } from 'src/app/services/servicedef.service';

@Component({

	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
	fullName: string;
	appTitle: string;
	IsAuthenticated: boolean;
	displayAbout = false;
	displayProfile = false;
	avatarURL: any;
	imageAvatarFlag = true;
	nameShortForm = 'VSV';

	@Input() sidenav: MatSidenav;
	@ViewChild('avatarHeader') avatarHeader: ElementRef;
	@Output() settingsLoaded: EventEmitter<any> = new EventEmitter();

	constructor(private authService: AuthService, private appMap: AppMapComponent, private serviceRequestsService: ServiceRequestsService,
		private userService: UserService, private _sanitizer: DomSanitizer, private agenciesService: AgenciesService,
		private documentService: CaseDocumentService,
		private inactivityService: InactivityService,
		private router: Router, public dialog: MatDialog, private globalService: GlobalService, private serviceDefService:ServiceDefService) {
		this.doLoadData();
	}
	ngOnInit() {
		if (this.sidenav != null && this.sidenav != undefined) {
			this.sidenav.open();
		}
		this.globalService.globalEvent.subscribe((event) => { this.doLoadAvatarImage(); });
		this.inactivityService.inactivityTimeoutEvent.subscribe(() => {
			this.userService.logout().subscribe(() => {
				this.authService.logout();
				console.log('Logout event triggered due to inactivity.');
			});
		});
	}

	doLoadData() {
		this.authService.isAuthenticated$.subscribe(value => {
			this.IsAuthenticated = value;
			if(!value) {
				this.fullName = '';
				this.nameShortForm = '';
				return;
			}
			this.fullName = (this.authService.loggedInUser != null && this.authService.loggedInUser != undefined) ? this.authService.loggedInUser.name : "";
			this.nameShortForm = (this.fullName == null || this.fullName.length == 0) ? '??' : this.fullName.split(" ").map((n) => n[0]).join("");
			if (this.authService.loggedInUser !== undefined && this.authService.loggedInUser != null) {
				this.userService.getAllSettings().subscribe(
					(data2) => {
						Settings.getInstance().generalSettingsList = data2;
						let bannerSettting = Settings.getInstance().getGeneralSettingByKey('bannertext');
						if (bannerSettting !== null) {
							Settings.getInstance().strBannerText = bannerSettting.value;
						}
						let bannerEnableSettting = Settings.getInstance().getGeneralSettingByKey('bannerenable');
						if (bannerSettting !== null) {
							if (bannerEnableSettting.value === 'true') {
								Settings.getInstance().enableMessageBanner = true;
							} else {
								Settings.getInstance().enableMessageBanner = false;
							}
						}
						this.settingsLoaded.emit(true);
						this.doLoadAvatarImage();
						const getAgenciesObservable = this.agenciesService.getAllAgencies();
						const getDocumentCategoriesObservable = this.documentService.getAllDocumentCategories();
						const getAllServiceRequestTypesObservable = this.serviceRequestsService.getAllServiceRequestTypes();
						const getAllRegionsObservable = this.serviceDefService.getAllRegions();
						const getAllStatusReasons = this.serviceRequestsService.getAllStatusReasons();

						forkJoin([
							getAgenciesObservable, 
							getDocumentCategoriesObservable, 
							getAllServiceRequestTypesObservable, 
							getAllRegionsObservable,
							getAllStatusReasons
							]).subscribe(
							(result) => {
								Settings.getInstance().agencyList = result[0];
								Settings.getInstance().documentCategoryList = result[1];
								Settings.getInstance().serviceRequestTypesList = result[2];
								Settings.getInstance().regionsList = result[3];
								Settings.getInstance().allStatusReasons = result[4];
								this.inactivityService.startMonitoring();
							},
							(error) => {
								Settings.getInstance().handleError('Error: unable to retrieve agencies data from the' +
									' service');
							}
						);
					},
					(error2) => {
						this.imageAvatarFlag = false;
					}
				);
			}
		});
		this.fullName = '';
		this.setTitle(this.appMap.appTitle);
	}

	setTitle(title: string) {
		this.appTitle = title;
	}
	doLoadAvatarImage() {
		this.imageAvatarFlag = false;
		this.userService.getUserProfileImage(this.authService.loggedInUser?.id).subscribe(
			(data1) => {
				if (!data1 || data1.size < 5) {
					this.imageAvatarFlag = false;
				} else {
					let tempImagePath = URL.createObjectURL(data1);
					this.avatarURL = 'url(' + tempImagePath + ')';
					this.imageAvatarFlag = true;
				}
			},
			(error1) => {
				this.imageAvatarFlag = false;
			}
		);
	}

	logout() {
		const noLogoutConfirmFlag = localStorage.getItem('do_not_confirm_logout');
		if (noLogoutConfirmFlag == null || noLogoutConfirmFlag == "0") {
			const message = 'Logout: Are you sure you want to exit the system ?';
			const dialogData = new ConfirmDialogModel('Please Confirm', message, "do_not_confirm_logout");

			const dialogRef = this.dialog.open(ConfirmDialogComponent, {
				width: '350px',
				height: '212px',
				data: dialogData,
				panelClass: 'custom-dialog-container'
			});
			dialogRef.afterClosed().subscribe(dialogResult => {
				if (dialogResult === true) {
					this.userService.logout().subscribe(() => {
						this.authService.logout();						
						//this.IsAuthenticated = false;

						//this.router.navigate(['login']);
						//location.reload();
					});
				} else {
					return;
				}
			});
		} else {
			this.userService.logout().subscribe(() => {
				//this.IsAuthenticated = false;
				this.authService.logout();
				//this.router.navigate(['login']);
				//location.reload();
			});
		}
	}

	public openMailMessage(): void {

		const to = Settings.getInstance().supportEmailAddress;
		const subject = 'The Connector Support Request';
		let body = '1. Please describe what you were doing when the incident occurred:%0D%0A %0D%0A';
		body += '2. What was the result that happened?:%0D%0A %0D%0A';
		body += '3. When did you notice this event?: %0D%0A %0D%0A';
		body += '4. Do you have any further information?:%0D%0A %0D%0A';
		body += 'Please attach or paste any relevant screen captures with this request.';

		const urlString  = 'mailto:' + to + '?subject=' + subject + '&body=' + body;

		window.open(urlString);
	}
	avatarClicked(event: any) {
		Settings.getInstance().handleError('click on avatar fetched from ' + event.sourceType);
	}
	showDialogAbout() {
		this.displayAbout = true;
	}
	doCancelFromAbout() {
		this.displayAbout = false;
	}
	showDialogProfile() {
		this.displayProfile = true;
	}
	doCancelFromProfile() {
		this.displayProfile = false;
	}
	getUrl() {
		return this.avatarURL;
	}
}
